export const environment = {
  production: false,
  // baseUrl:'http://103.118.16.132:1999/'
  baseUrl:"https://localhost:52001/"
};